
export { typography } from "/vercel/path0/libs/styles/src/lib/typography.css.ts"